import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getPublicDocumentsApi, postPublicDocumentsApi } from "@Shared/@Utils/ajax";
export const getDocuments = async token => {
  return getPublicDocumentsApi({}, token, "/guest-upload");
};
export const sendComment = async (token, documentId, comment) => {
  const endpoint = `/guest-upload/${documentId}/comment`;
  return postPublicDocumentsApi({
    comment
  }, token, endpoint);
};
export const updatePin = async (token, oldCode, code) => {
  const endpoint = "/guest-upload/update-code";
  return postPublicDocumentsApi({
    oldCode,
    code
  }, token, endpoint);
};
export const verifyPin = async (token, code) => {
  const endpoint = "/guest-upload/verify-code";
  return postPublicDocumentsApi({
    code
  }, token, endpoint);
};
export const createSignedUrls = (filesInfo, token, documentRequestId) => {
  const endpoint = `/guest-upload/signed-s3-url`;
  const payload = {
    documentRequestId
  };
  return postPublicDocumentsApi(_objectSpread(_objectSpread({}, payload), {}, {
    filesInfo
  }), token, endpoint);
};
export const downloadSampleDocument = async (token, documentId) => {
  const endpoint = `/guest-upload/sample-document/${documentId}`;
  return getPublicDocumentsApi({}, token, endpoint);
};
export const markUploadCompleted = (token, classificationType, documentId, documentRequestId, encrypted = false) => {
  const endpoint = `/guest-upload/${documentId}`;
  return postPublicDocumentsApi({
    classificationType,
    documentRequestId,
    encrypted
  }, token, endpoint);
};